export const LOADING_STARTED = 'LOADING_STARTED';
export const USER_LIST_LOADED = 'USER_LIST_LOADED';
export const DEXT_USER_LIST_LOADED = 'DEXT_USER_LIST_LOADED';
export const DEXT_USER_ADDED_TO_TEAM = 'DEXT_USER_ADDED_TO_TEAM';
export const DEXT_USER_CHANGE_DAILY_DIGEST = 'DEXT_USER_CHANGE_DAILY_DIGEST';
